import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const WelcomeCard = ({ user, stats }) => {
  const currentHour = new Date().getHours();
  const greeting =
    currentHour < 12 ? 'Good morning' : currentHour < 18 ? 'Good afternoon' : 'Good evening';
  const firstName = (user?.name || 'there').split(' ')[0];

  return (
    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-slate-900 via-slate-800 to-sky-900 text-white p-6 sm:p-8 shadow-lg">
      <div className="absolute -right-10 -top-10 w-48 h-48 rounded-full bg-sky-500/20 blur-2xl" />
      <div className="absolute -left-8 bottom-0 w-40 h-40 rounded-full bg-indigo-500/10 blur-2xl" />

      <div className="relative flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
        <div className="min-w-0">
          <p className="text-sky-300 text-xs font-semibold uppercase tracking-[0.18em] mb-2">
            HireBroker · Property seeker
          </p>
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight mb-2">
            {greeting}, {firstName}
          </h2>
          <p className="text-slate-300 text-sm sm:text-base max-w-xl leading-relaxed">
            Track saved homes, manage specific property requests, and book verified agents — all
            from one place.
          </p>

          <div className="flex flex-wrap gap-2 mt-5">
            <Link
              to="/property-search-browse"
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-white text-slate-900 text-sm font-semibold hover:bg-sky-50 transition-colors"
            >
              <Icon name="Search" size={16} />
              Browse properties
            </Link>
            <Link
              to="/notice-board"
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-white/10 border border-white/20 text-white text-sm font-semibold hover:bg-white/15 transition-colors"
            >
              <Icon name="ClipboardList" size={16} />
              Specific Property Request
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-2 sm:gap-3 w-full lg:w-auto lg:min-w-[320px]">
          <StatPill icon="Heart" label="Saved" value={stats?.saved ?? 0} />
          <StatPill icon="ClipboardList" label="Requests" value={stats?.requests ?? 0} />
          <StatPill icon="Calendar" label="Bookings" value={stats?.bookings ?? 0} />
        </div>
      </div>
    </div>
  );
};

const StatPill = ({ icon, label, value }) => (
  <div className="rounded-xl bg-white/10 border border-white/10 px-3 py-3 text-center backdrop-blur-sm">
    <Icon name={icon} size={16} className="mx-auto text-sky-300 mb-1" />
    <p className="text-xl font-bold tabular-nums">{value}</p>
    <p className="text-[10px] uppercase tracking-wide text-slate-300 mt-0.5">{label}</p>
  </div>
);

export default WelcomeCard;
